import Router from "../router";
import axios from "./AxiosConfig";
import { Auth } from "../utils/auth";
import i18n from "../utils/i18n/i18n";

export class HealthCheckApi {

    async check() {
        return await axios.get(Router.apiBaseUrl + Router.apiHealthCheck, {})
        .then(response => {
            return response
        }).catch(error => {
            return error.response
        })
    }

    async checkApi(data) {
        // Si la llamada es a Appearance, nunca redirigir a /maintenance.
        // Dejamos que la app use colores por defecto aunque la API falle o tenga CORS.
        if (data?.config?.url &&
            (data.config.url.includes(Router.apiAppearance) ||
             data.config.url.includes(Router.apiAppearanceRestricted))) {
            return data;
        }

        const { logout } = new Auth();

        if (data?.status === 500 || data?.status === 404 || !data.status) {
            
            // Si el error es por falta de conexión (offline), NO redirigir a /maintenance
            if (!navigator.onLine) {
                return data;
            }

            const resp = await this.check();
            if (!window.location.href.includes(Router.appMaintenance) && (resp?.status === 400 || resp?.status === 404 || resp?.status === 500 || !resp)) {
                window.location.href = Router.appMaintenance
                return
            } else if (data?.response?.status === 401) {
                logout()
                window.location.href = Router.appLogin
                return
            } else if (data?.response?.status === 403) {
                const message = data?.response?.data ?? i18n.t('common.empty.notFound')
                const hash = window.btoa(
                    unescape(encodeURIComponent(message))
                )
                window.location.href = `${Router.appForbidden}?name=${hash}`
                return
            }
        }
        return data;
    }
}